<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page clicks-page mt-4" v-else-if="loaded" >
        
        <b-input-group class="mb-3" >
            <b-form-input v-model="filter" placeholder="Type to search..." class="search-input atlass-input-borderless" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>
        
        <div class="w-100 clicks-container overflow-auto" >
            
            <div class="col-12 click font-size-14" v-for="(click, index) in matches"  >
                <div class="row ml-1 ml-md-5 pt-4 pb-4 border-left-gray" >
                    
                    <div class="col-12 pl-0"  >
                        <div class="col-12" > <b>Referral URL:</b> <span > {{click.referralURL}}  </span> </div>
                        <div class="col-12" > <b>Previous URL:</b> <span v-if="click.previousURL" > {{click.previousURL}}  </span> <span v-else-if="click.previousURL == '' " class="graymedium-color" > Unknown </span> </div>
                        <div class="col-12 " v-if="click.sourceTag && click.sourceTag.tag != null " > <b>Source tag:</b> <span class="Text-color--main font-weight-bold" > {{click.sourceTag.tag}} </span> </div>
                    </div>
                    
                    <div class="col-12 " > 
                        <span class="timeline-bullet" ></span> {{ formatDate(click) }} 
                        
                        <span class="font-size-16" v-if="isAdmin" > <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--${click.id}`"  />  </span>
                        <b-tooltip :target="`tooltip--${click.id}`" placement="right" triggers="hover" custom-class="tooltip" >
                            IP: {{ click.IP }} <br>
                            IP Salt: {{ click.IP_SALT }} <br>
                            SessionID: {{ click.SessionID }} <br>
                            Agent: {{ click.agent }} <br>
                        </b-tooltip>
                    </div>
                    
                </div>
            </div>
            
            <div class="col-12 text-center mt-2" v-if="!allDataLoaded" > 
                <a @click="loadMore" class="btn" :class="[{'btn-secondary': allDataLoaded},{'btn-primary': !allDataLoaded}]"  > Load more </a>
            </div>
            
        </div>
        
    </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import helper from '@/helpers/helpers.js';    
    
export default {
    name: 'clicksComponent',
    props: {
        data: { 
            type: [Array],
        },
        origin: { 
            type: [String],
            default: 'component'
        },
        allDataLoaded:{
            type: [Boolean],
            default: false
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        //console.log(this.data)
        this.loaded = true;
    },
    beforeDestroy() {
        
    },
    methods: {
        formatDate(a){
            //return this.$moment.unix(a.datetime).format( 'HH:mm:ss MMM D, YYYY' )
            return helper.formatDate( a.datetime, 'HH:mm:ss MMM D, YYYY' )
        },
        loadMore(){
            
            //console.log(this.allDataLoaded)
            
            if( this.allDataLoaded ){
                this.$toast.warn({
                    title: 'Nothing more to load',
                    message:  'All clicks have been loaded'
                })
            }else{
                //console.log(this)
                if( this.origin == 'tab' ){
                    this.$parent.$parent.$parent.get_data('clicks')
                }else{
                    this.$parent.get_data('clicks')
                }
                    
            }
                
            
        },
        
    },
    computed: {
        isAdmin(){
            return this.$store.getters.isAdmin
        },
        
        matches() {
            return this.filter
                ? this.data.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if ( row['referralURL'].toLowerCase().includes(this.filter.toLowerCase()) || row['previousURL'].toLowerCase().includes(this.filter.toLowerCase()) ) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
    
    @import '@/assets/css/variables.scss';
    
    .reset-filter{
        position: absolute;
        right:0;
        line-height: 50px;
        font-size: 18px;
        margin-right: 9px;
        margin-top: 9px;
        color: #777;
        z-index: 999;
        cursor: pointer
    }

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .click span{
        word-break: break-all;
    }
    
    .clicks-container{
        max-height: 54vh;
        max-height: calc( 100vh - 430px );
    }
    
    @media screen and (max-width: 767px){
        .clicks-container{
            max-height: calc( 100vh - 270px );
            max-height: 100%;
            height: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/clicks.vue